module.exports = __webpack_public_path__ + "static/media/tick.c5ef8d1c.svg";